import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className="about-sec pt-6 pb-6">
      <div className="container">
        <div className="row">
          {/* Left Column (Image Area) */}
          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
            <div className="about-img">
              <div className="row">
                <div className="col-lg-7 p-1 wow zoomIn" data-wow-delay="0.2s">
                  <div className="about-img1">
                    <img src="/project/images/about-img.jpg" alt="" />
                  </div>
                </div>
                <div className="col-lg-5 p-1">
                  <div className="about-img-text wow fadeInUp" data-wow-delay="0.3s">
                    <h2>30+</h2>
                    <span>Years Experience</span>
                    <p>Lorem ipsum dolor sit.</p>
                  </div>
                  <div className="about-img2 wow zoomIn" data-wow-delay="0.4s">
                    <img src="/project/images/about-img2.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column (Text Content) */}
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="about-text">
              <h6>About Us</h6>
              <h2>From Junk Cars To Quality Auto Parts We're Here To Help</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat est nam incidunt,
                nostrum temporibus quae eaque ipsam tenetur molestias obcaecati...
              </p>
              <ul>
                <li className="wow fadeInUp" data-wow-delay="0.4s">
                  <div className="avout-li-box">
                    <img src="/project/images/about-icon.png" alt="" />
                    <h5>Our Mission</h5>
                  </div>
                  <div className="avout-li-text">
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
                      cupiditate minus repellat...
                    </p>
                  </div>
                </li>
                <li className="wow fadeInUp" data-wow-delay="0.6s">
                  <div className="avout-li-box">
                    <img src="/project/images/about-icon-1.png" alt="" />
                    <h5>Our Vision</h5>
                  </div>
                  <div className="avout-li-text">
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
                      cupiditate minus repellat...
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="btn-red mt-4">
              <Link to="/about">Read more</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
